/* jshint esversion: 6 */
/* jshint esversion: 11 */
/* jshint ignore:start */
import axios from 'axios';
import { useContext, useEffect, useRef, useState } from 'react';
import { MdFemale, MdMale } from 'react-icons/md';
import { MyContext } from '../../Context/MyProvider';
import { IoCameraOutline } from 'react-icons/io5';
import { showToast } from '../../showTost';
import { useTranslation } from 'react-i18next';
import secureLocalStorage from "react-secure-storage";
import ImageLoad from '../ImageLoad';
import DImage from "../../assets/Image/default_pic.png";

const AddPatient = ({ Relation, BooldType, Data }) => {

    const { t } = useTranslation();
    const { ApiBaseUrl, ImgBaseUrl, setPatientStatus } = useContext(MyContext);

    const [addPatientData, setAddPatientData] = useState({ PatientName: "", Relationship: "", Relationshipid: "", BooldType: "", BooldTypeid: "", PatientGender: "", PatientAge: "", NationalID: "", Height: "", Weight: "", Allergies: "", MedicalHistory: "" });
    const [isFocused, setIsFocused] = useState(false);
    const [isFocused2, setIsFocused2] = useState(false);
    const [patientPhoto, setPatientphoto] = useState("");
    const [patientEditPhoto, setPatientEditphoto] = useState("");

    const Inputref = useRef(null);
    const wrapperRef = useRef(null);
    const wrapperRef2 = useRef(null);

    useEffect(() => {
        if (Data) {
            setPatientphoto(ImgBaseUrl + Data.profile_image);
            const Relationship = Relation.find((item) => item.id === Number(Data.relationship));
            const BooldTypeData = BooldType.find((item) => item.id === Number(Data.blood_type));
            setAddPatientData({
                PatientName: Data.name,
                Relationship: Relationship?.name,
                Relationshipid: Data.relationship,
                BooldType: BooldTypeData?.name,
                BooldTypeid: Data.blood_type,
                PatientGender: Data.gender,
                PatientAge: String(Data.patient_age),
                NationalID: Data.national_id,
                Height: Data.height,
                Weight: Data.weight,
                Allergies: Data.allergies,
                MedicalHistory: Data.medical_history
            });
        }
    }, [Data]);

    const validatePatientData = () => {
        for (let key in addPatientData) {
            if (String(addPatientData[key]).trim() === "") {
                return false;
            }
        }
        return true;
    };

    const SubmitHandle = () => {
        const Userid = secureLocalStorage.getItem("Userid");
        const Url = Data ? "/customer/edit_family_member" : "/customer/add_family_member";

        if (!patientPhoto) {
            showToast({ title: t("Add Patient Photo"), id: "warning" });
            return;
        }

        if (!validatePatientData()) {
            showToast({ title: t("Add Patient Details"), id: "warning" });
            return;
        }

        if (Userid) {
            const formData = new FormData();
            formData.append("profile_image", patientEditPhoto);
            formData.append("customer_id", Userid);
            if (Data) { formData.append("fid", Data.id); }
            formData.append("name", addPatientData.PatientName);
            formData.append("relationship", addPatientData.Relationshipid);
            formData.append("blood_type", addPatientData.BooldTypeid);
            formData.append("gender", addPatientData.PatientGender);
            formData.append("patient_age", addPatientData.PatientAge);
            formData.append("national_id", addPatientData.NationalID);
            formData.append("height", addPatientData.Height);
            formData.append("weight", addPatientData.Weight);
            formData.append("allergies", addPatientData.Allergies);
            formData.append("medical_history", addPatientData.MedicalHistory);

            axios.post(`${ApiBaseUrl + Url}`, formData)
                .then((res) => {
                    const { ResponseCode, message } = res.data;
                    if (ResponseCode === 200) {
                        showToast({ title: message, id: "success" });
                        setPatientStatus("123");
                        setPatientphoto("");
                        setAddPatientData({ PatientName: "", Relationship: "", Relationshipid: "", BooldType: "", BooldTypeid: "", PatientGender: "", PatientAge: "", NationalID: "", Height: "", Weight: "", Allergies: "", MedicalHistory: "" });
                    }
                })
                .catch((error) => { console.error(error); });
        }
    };

    const HandleRelationship = (e) => {
        if (addPatientData.Relationshipid) {
            setAddPatientData({ ...addPatientData, Relationship: e, Relationshipid: "" });
        } else {
            const selectedRelation = Relation.find(item => item.name.toLowerCase() === e.toLowerCase());
            const Id = selectedRelation && selectedRelation.id;
            setAddPatientData({ ...addPatientData, Relationship: selectedRelation ? selectedRelation.name : e, Relationshipid: Id });
        }
    };

    const HandleBooldType = (e) => {
        if (addPatientData.BooldTypeid) {
            setAddPatientData({ ...addPatientData, BooldType: e, BooldTypeid: "" });
        } else {
            const selectedRelation = BooldType.find(item => item.name.toLowerCase() === e.toLowerCase());
            const Id = selectedRelation && selectedRelation.id;
            setAddPatientData({ ...addPatientData, BooldType: selectedRelation ? selectedRelation.name : e, BooldTypeid: Id });
        }
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setIsFocused(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => { document.removeEventListener('mousedown', handleClickOutside); };
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (wrapperRef2.current && !wrapperRef2.current.contains(event.target)) {
                setIsFocused2(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => { document.removeEventListener('mousedown', handleClickOutside); };
    }, []);

    const inputClass = "w-full px-4 py-2.5 rounded-xl border border-slate-200 bg-slate-50/60 text-slate-800 text-sm font-medium placeholder-slate-400 focus:outline-none focus:border-indigo-500 focus:bg-white focus:ring-2 focus:ring-indigo-100 transition-all duration-200";
    const labelClass = "text-xs font-bold text-slate-500 uppercase tracking-wider mb-1.5 block";

    return (
        <div className="w-full">
            {/* Header */}
            <div className="mb-6">
                <span className="text-xs font-bold uppercase tracking-wider text-indigo-600 bg-indigo-50 px-2.5 py-1 rounded-md inline-block mb-1">
                    {Data ? t("Edit Profile") : t("New Patient")}
                </span>
                <h2 className="text-xl font-extrabold text-slate-800 leading-tight">
                    {Data ? t("Update Patient Info") : t("Add Patient Profile")}
                </h2>
                <p className="text-xs text-slate-400 mt-0.5">{t("Fill in the details below to save patient information.")}</p>
            </div>

            {/* Photo Upload */}
            <div className="flex items-center gap-5 mb-6 pb-6 border-b border-slate-100">
                <div className="relative shrink-0">
                    <div className="w-20 h-20 rounded-2xl overflow-hidden border-2 border-slate-200 shadow-sm bg-slate-100">
                        {patientPhoto
                            ? <ImageLoad src={patientPhoto} CustomeStyle="w-full h-full object-cover" alt="patientPhoto" />
                            : <img src={DImage} className="w-full h-full object-cover" alt="default_pic" />
                        }
                    </div>
                    <button
                        onClick={() => Inputref.current.click()}
                        className="absolute -bottom-2 -right-2 w-7 h-7 rounded-full bg-indigo-600 text-white flex items-center justify-center shadow-md hover:bg-indigo-700 active:scale-95 transition-all border-2 border-white"
                        aria-label="Upload photo"
                    >
                        <IoCameraOutline className="text-sm" />
                    </button>
                    <input ref={Inputref} type="file" className="hidden" onChange={(e) => {
                        setPatientphoto(URL.createObjectURL(e.target.files[0]));
                        setPatientEditphoto(e.target.files[0]);
                    }} />
                </div>
                <div>
                    <p className="font-bold text-slate-700 text-sm">{t("Patient Photo")}</p>
                    <p className="text-xs text-slate-400 mt-0.5 leading-relaxed">{t("Upload a clear profile photo.")}</p>
                    <button
                        onClick={() => Inputref.current.click()}
                        className="mt-2 text-xs font-bold text-indigo-600 bg-indigo-50 hover:bg-indigo-100 border border-indigo-100 px-3 py-1.5 rounded-lg transition-all duration-200 flex items-center gap-1.5"
                    >
                        <IoCameraOutline className="text-sm" />
                        {t("Add Photo")}
                    </button>
                </div>
            </div>

            {/* Form Fields */}
            <div className="flex flex-col gap-4">

                {/* Patient Name */}
                <div>
                    <label className={labelClass}>{t("Patient Name")}</label>
                    <input
                        type="text"
                        value={addPatientData.PatientName}
                        onChange={(e) => setAddPatientData({ ...addPatientData, PatientName: e.target.value })}
                        className={inputClass}
                        placeholder={t("Enter full name")}
                    />
                </div>

                {/* Relationship & Blood Type */}
                <div className="grid grid-cols-2 gap-3">
                    <div ref={wrapperRef} className="relative">
                        <label className={labelClass}>{t("Relationship")}</label>
                        <input
                            onFocus={() => setIsFocused(true)}
                            value={addPatientData.Relationship}
                            onChange={(e) => HandleRelationship(e.target.value)}
                            type="text"
                            className={inputClass}
                            placeholder={t("Relationship")}
                        />
                        {isFocused && (
                            <div className="absolute top-full left-0 mt-1.5 bg-white border border-slate-100 rounded-xl shadow-xl z-20 w-full max-h-[200px] overflow-y-auto scroll-container py-1.5">
                                {Relation.map((item, index) => (
                                    <div
                                        key={index}
                                        onClick={() => { setAddPatientData({ ...addPatientData, Relationship: item.name, Relationshipid: item.id }); setIsFocused(false); }}
                                        className="px-4 py-2.5 text-sm font-medium text-slate-700 hover:bg-indigo-50 hover:text-indigo-700 cursor-pointer transition-colors"
                                    >
                                        {item.name}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>

                    <div ref={wrapperRef2} className="relative">
                        <label className={labelClass}>{t("Blood Type")}</label>
                        <input
                            onFocus={() => setIsFocused2(true)}
                            value={addPatientData.BooldType}
                            onChange={(e) => HandleBooldType(e.target.value)}
                            type="text"
                            className={inputClass}
                            placeholder={t("Blood Type")}
                        />
                        {isFocused2 && (
                            <div className="absolute top-full left-0 mt-1.5 bg-white border border-slate-100 rounded-xl shadow-xl z-20 w-full max-h-[200px] overflow-y-auto scroll-container py-1.5">
                                {BooldType.map((item, index) => (
                                    <div
                                        key={index}
                                        onClick={() => { setAddPatientData({ ...addPatientData, BooldType: item.name, BooldTypeid: item.id }); setIsFocused2(false); }}
                                        className="px-4 py-2.5 text-sm font-medium text-slate-700 hover:bg-indigo-50 hover:text-indigo-700 cursor-pointer transition-colors"
                                    >
                                        {item.name}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>

                {/* Gender */}
                <div>
                    <label className={labelClass}>{t("Patient Gender")}</label>
                    <div className="flex gap-3">
                        <button
                            onClick={() => setAddPatientData({ ...addPatientData, PatientGender: "Male" })}
                            className={`flex-1 flex items-center justify-center gap-2 py-2.5 rounded-xl border-2 font-bold text-sm transition-all duration-200 ${addPatientData.PatientGender === "Male"
                                    ? "bg-indigo-600 border-indigo-600 text-white shadow-sm"
                                    : "bg-slate-50 border-slate-200 text-slate-500 hover:border-indigo-300 hover:text-indigo-600"
                                }`}
                        >
                            <MdMale className="text-lg" />
                            {t("Male")}
                        </button>
                        <button
                            onClick={() => setAddPatientData({ ...addPatientData, PatientGender: "Female" })}
                            className={`flex-1 flex items-center justify-center gap-2 py-2.5 rounded-xl border-2 font-bold text-sm transition-all duration-200 ${addPatientData.PatientGender === "Female"
                                    ? "bg-pink-500 border-pink-500 text-white shadow-sm"
                                    : "bg-slate-50 border-slate-200 text-slate-500 hover:border-pink-300 hover:text-pink-500"
                                }`}
                        >
                            <MdFemale className="text-lg" />
                            {t("Female")}
                        </button>
                    </div>
                </div>

                {/* Age & National ID */}
                <div className="grid grid-cols-2 gap-3">
                    <div>
                        <label className={labelClass}>{t("Patient Age")}</label>
                        <input
                            type="number"
                            value={addPatientData.PatientAge}
                            onChange={(e) => setAddPatientData({ ...addPatientData, PatientAge: e.target.value })}
                            className={inputClass}
                            placeholder={t("Age")}
                        />
                    </div>
                    <div>
                        <label className={labelClass}>{t("National ID")}</label>
                        <input
                            type="text"
                            value={addPatientData.NationalID}
                            onChange={(e) => setAddPatientData({ ...addPatientData, NationalID: e.target.value })}
                            className={inputClass}
                            placeholder={t("National ID")}
                        />
                    </div>
                </div>

                {/* Height & Weight */}
                <div className="grid grid-cols-2 gap-3">
                    <div>
                        <label className={labelClass}>{t("Height")} <span className="text-slate-300 font-normal normal-case tracking-normal">(cm)</span></label>
                        <input
                            type="number"
                            value={addPatientData.Height}
                            onChange={(e) => setAddPatientData({ ...addPatientData, Height: e.target.value })}
                            className={inputClass}
                            placeholder="e.g. 170"
                        />
                    </div>
                    <div>
                        <label className={labelClass}>{t("Weight")} <span className="text-slate-300 font-normal normal-case tracking-normal">(kg)</span></label>
                        <input
                            type="number"
                            value={addPatientData.Weight}
                            onChange={(e) => setAddPatientData({ ...addPatientData, Weight: e.target.value })}
                            className={inputClass}
                            placeholder="e.g. 65"
                        />
                    </div>
                </div>

                {/* Allergies */}
                <div>
                    <label className={labelClass}>{t("Allergies")}</label>
                    <input
                        type="text"
                        value={addPatientData.Allergies}
                        onChange={(e) => setAddPatientData({ ...addPatientData, Allergies: e.target.value })}
                        className={inputClass}
                        placeholder={t("List any known allergies")}
                    />
                </div>

                {/* Medical History */}
                <div>
                    <label className={labelClass}>{t("Medical History")}</label>
                    <input
                        type="text"
                        value={addPatientData.MedicalHistory}
                        onChange={(e) => setAddPatientData({ ...addPatientData, MedicalHistory: e.target.value })}
                        className={inputClass}
                        placeholder={t("Any relevant medical history")}
                    />
                </div>

                {/* Submit Button */}
                <button
                    onClick={SubmitHandle}
                    className="w-full mt-2 py-3.5 bg-indigo-600 hover:bg-indigo-700 active:scale-[0.98] text-white font-extrabold text-sm tracking-wider rounded-2xl shadow-sm hover:shadow-md transition-all duration-200 uppercase"
                >
                    {Data ? t("Update Patient") : t("Save Patient")}
                </button>
            </div>
        </div>
    );
};

export default AddPatient;
/* jshint ignore:end */